import '.bt{position:relative;}.ssr-plugin'
import '.iu{width:64px;}.ssr-plugin'
import '.iv{height:64px;}.ssr-plugin'
import '.b8{flex-shrink:0;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.iw{bottom:-4px;}.ssr-plugin'
import '.cw{right:-4px;}.ssr-plugin'
import '.dh{border-radius:50%;}.ssr-plugin'
import '.ix{border:2px solid var(--shades-white);}.ssr-plugin'
import '.t{overflow:hidden;}.ssr-plugin'
import '.iy{width:32px;}.ssr-plugin'
import '.iz{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { resizeImage } from '@app/util/helpers'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bt iu iv b8"
    >
      {initiativeImage ? (
        <Image
          src={resizeImage(initiativeImage, 128)}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="p iw cw dh ix t iy iz"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
